import { render, staticRenderFns } from "./BecameAProspect.vue?vue&type=template&id=226e075b&scoped=true&"
import script from "./BecameAProspect.vue?vue&type=script&lang=js&"
export * from "./BecameAProspect.vue?vue&type=script&lang=js&"
import style0 from "./BecameAProspect.vue?vue&type=style&index=0&id=226e075b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226e075b",
  null
  
)

export default component.exports